<template>
  <v-col
    cols="12"
    sm="3"
    class="pb-10"
  >
    <v-btn
      color="primary"
      @click="incrementStep"
    >Continue</v-btn>
  </v-col>
</template>

<script>
export default {
  name: 'btnContinue',
  data: () => ({
    temp: null,
  }),
  computed: {
    benefitFlag() {
      return this.$store.state.prospectPacket.flags.hasBenefitPacket;
    },
  },
  methods: {
    incrementStep() {
      const step = this.$store.state.stepper.currentStep;

      this.$store.commit('goToStep', Number(step) + 1);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
